import { useTranslation } from 'react-i18next';

import { Typography } from '@packages/fenrir/components/typography';

import { NoDataEnDash } from '../no-data-en-dash/no-data-en-dash';

type Props = {
  translationKey: string;
  value?: string;
};

export const LocalizedEnum = ({ translationKey, value }: Props) => {
  const { t } = useTranslation();
  if (!value) {
    return <NoDataEnDash />;
  }
  const v = value.replace(/\s/g, '_').toLowerCase();
  return (
    <Typography variant="body2">
      {t([`${translationKey}.${v}`, value])}
    </Typography>
  );
};
